import { ENV_VARS } from '@/env';

// we have only one entrypoint via api path
const BASE = `${ENV_VARS.REACT_APP_API_URL}/api`;
const BASE_ORIGIN = `${ENV_VARS.REACT_APP_ORIGIN_API}/api`;
const BASE_IDENTITY = `${ENV_VARS.REACT_APP_OIDC_AUTHORITY}/api`;
const BASE_PRICING = `${ENV_VARS.REACT_APP_PRICING_API_URL}`;
const BASE_MASTER_DATA = `${ENV_VARS.REACT_APP_MASTER_DATA_API_URL}/v2`;

export const API = {
  ACCESSORIALS: `${BASE_PRICING}/accessorial`,
  AUCTION: `${BASE}/AuctionAPI`,
  BASE,
  BASE_IDENTITY,
  BASE_ORIGIN,
  BASE_PRICING,
  CARRIER_EMAIL_REGISTRATION: `${BASE}/CarrierEmailRegistration`,
  CONTRACTS: `${BASE_PRICING}/contract`,
  DASHBOARD: `${BASE}/Dashboard`,
  ETRAILER: `${BASE}/etrailer/TrailerInfo`,
  LOSS_AND_DAMAGE: `${BASE}/LossAndDamageAPI`,
  MASTER_DATA_PUBLIC: `${BASE_MASTER_DATA}/public`,
  MASTER_SETTINGS: `${BASE}/MasterSettingsAPI`,
  MESSAGE_CENTER: `${BASE}/MessageCenterAPI`,
  OVERCHARGE_CLAIM: `${BASE}/OverchargeClaimAPI`,
  PDF_EXPORT: `${BASE}/PDFExport`,
  PO: `${BASE}/PoAPI`,
  POV: `${BASE}/PovAPI`,
  // TODO: verify looks like API isn't case-sensitive
  POV2: `${BASE}/POVAPI`,
  PovAPI: `${BASE}/PovAPI`,
  PRECLAIM: `${BASE}/PreClaimAPI`,
  PRIMARY: `${BASE}/PrimaryAPI`,
  PROCUREMENT: `${BASE}/ProcurementAPI`,
  QUOTE_DASHBOARD: `${BASE}/QuoteDashboard`,
  QUOTE_DASHBOARD_V2: `${BASE}/spot-quote/dashboard/bids`,
  RATE: `${BASE}/rate`,
  ROUTING_GUIDE: `${BASE}/RoutingGuideAPI`,
  SAVERS: `${BASE}/Savers`,
  SECURITY: `${BASE}/SecurityAPI`,
  SHIPMENT: `${BASE}/ShipmentAPI`,
  SPOT_QUOTE: `${BASE}/SpotQuote`,
  SPOT_QUOTE_ROUTING_GUIDE_V2: `${BASE}/spot-quote/routing-guide`,
  SPOT_QUOTE_V2: `${BASE}/spot-quote`,
  SPOT_QUOTE2: `${BASE}/spotquote`,
  // TODO: verify looks like API isn't case-sensitive
  TARIFFS: `${BASE_PRICING}/tariffs`,
  VISIBILITY: `${BASE}/VisibilityAPI`,
};
